export default "__VITE_ASSET__DYOfYyXs__"